import {Button, Card, Form, Input, Select, Spin} from 'antd';
import React from "react";
import moment from "moment";

class Create extends React.Component {
  constructor() {
    super();
    this.state = {
      // showManpower: '',
    }
  }

  componentDidMount() {
    const {paramsId, fetch} = this.props;
    if (paramsId) {
      fetch(paramsId);
    }
    this.props.searchManpower('');
  }

  componentWillReceiveProps(nextProps: Readonly<P>, nextContext: any): void {
    if (nextProps && ((nextProps.paramsId).toString() !== (this.props.paramsId).toString())) {
      nextProps && nextProps.fetch(nextProps.paramsId);
    }
  }

  componentWillUnmount() {
    this.setState( { showManpower: '' });
  }


  handleSubmit = (e) => {
    const {match, paramsId} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (paramsId) {
        this.props.onSubmit(values, paramsId);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  searchManpower = (id, searchString) => {
    this.props.searchManpower(searchString);
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const { showManpower } = this.state;
    const {data, loading, filters, title, resource, form, searchManpower, manpower, selectedDate} = this.props;
    const allocatedManpower = data.allocate && data.allocate.filter(item => {
      if (moment(selectedDate).format('YYYY-MM-DD') === (moment(item && item.date).format('YYYY-MM-DD'))) {
        return true;
      }
      return false;
    });
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={<div>Activity Serial Number - {data.activitySerialNo}</div>}>
          {
            <Form onSubmit={this.handleSubmit} layout="vertical">

              <div style={style}>
                <div>
                  <Form.Item key={`_id`}>
                    {getFieldDecorator(`_id`, {
                      rules: [{required: false, message: `Id is required!`}],
                      initialValue: data._id,
                    })(<Input disabled style={{display: 'none'}} />)
                    }
                  </Form.Item>
                  <Form.Item key={`manpower`} label={'Manpower Resource'}>
                    {getFieldDecorator(`manpower`, {
                      rules: [{required: false, message: `Manpower Resource is required!`}],
                      initialValue: allocatedManpower && allocatedManpower[0] && allocatedManpower[0].manpower && allocatedManpower[0].manpower._id,
                    })(<Select
                      showSearch
                      style={{width: '100%'}}
                      placeholder="Please select"
                      filterOption={false}
                      notFoundContent={null}
                      // autoClearSearchValue={false}
                      onSearch={this.searchManpower.bind(this, data._id)}
                    >
                      {/*{showManpower === item._id ? '' : (item.allocate && item.allocate.manpower && item.allocate.manpower._id) ? <Select.Option key={item.allocate.manpower._id+'1'} value={item.allocate.manpower._id}>{item.allocate.manpower.name}</Select.Option> : ''}*/}
                      {
                        manpower && manpower.map(items => {
                          return <Select.Option key={items._id} value={items._id}>{items.name}</Select.Option>
                        })
                      }
                    </Select>)
                    }
                  </Form.Item>
                </div>
              </div>
              <Form.Item>
                <Button type="primary" className="gx-mb-0 gx-mt-4" htmlType="submit" loading={loading}>
                  {this.props.title === 'EDIT' ? 'ALLOCATE' : 'CREATE'}
                </Button>
              </Form.Item>
            </Form>
          }
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
